module.exports = __webpack_public_path__ + "img/upload.9abcaccf.jpeg";